import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HseTabBar } from "../HseTabBar";
import { detectRiskTab, RISK_TABS } from "./riskUtils";

export function RiskSubnav({ active }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const activeId = active || detectRiskTab(location.pathname);

  return (
    <HseTabBar
      tabs={RISK_TABS.map((tab) => ({
        id: tab.id,
        label: t(tab.labelKey),
        path: tab.path,
      }))}
      activeId={activeId}
      onSelect={(tab) => navigate(tab.path)}
      ariaLabel={t("hse.risk.nav.aria")}
    />
  );
}
